/**
 * EU + UK detection via IANA timezone.
 * Imperfect (VPN / odd locale setups slip through) but cheap, private,
 * and good enough to decide whether to show a cookie consent banner.
 * Countries under GDPR scope: EU-27 + UK (post-Brexit UK-GDPR mirrors EU).
 */

const EU_UK_TIMEZONES = new Set([
  // UK
  "Europe/London", "Europe/Belfast",
  // Ireland
  "Europe/Dublin",
  // Western EU
  "Europe/Paris", "Europe/Brussels", "Europe/Amsterdam", "Europe/Luxembourg",
  "Europe/Berlin", "Europe/Vienna", "Europe/Zurich",
  // Nordics
  "Europe/Copenhagen", "Europe/Stockholm", "Europe/Oslo", "Europe/Helsinki",
  // Iberia
  "Europe/Madrid", "Europe/Lisbon", "Atlantic/Madeira", "Atlantic/Azores",
  "Atlantic/Canary",
  // Italy + Malta + Cyprus
  "Europe/Rome", "Europe/Malta", "Asia/Nicosia", "Europe/Nicosia",
  // Central / Eastern EU
  "Europe/Warsaw", "Europe/Prague", "Europe/Bratislava", "Europe/Budapest",
  "Europe/Ljubljana", "Europe/Zagreb", "Europe/Bucharest", "Europe/Sofia",
  "Europe/Athens", "Europe/Vilnius", "Europe/Riga", "Europe/Tallinn",
]);

export function isEuOrUk(): boolean {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return EU_UK_TIMEZONES.has(tz);
  } catch {
    return false;
  }
}
